// src/pages/AccessDeniedPage.tsx
import React from 'react';
import { Box, Button, Container, Typography, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Home, Lock } from '@mui/icons-material';

const AccessDeniedPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Container 
      maxWidth="xl" 
      sx={{ 
        py: 4, 
        minHeight: '80vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}
    >
      <Box 
        sx={{ 
          textAlign: 'center', 
          maxWidth: 600,
          p: 4,
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          bgcolor: 'white'
        }}
      >
        <Box 
          sx={{ 
            width: 120, 
            height: 120, 
            borderRadius: '50%', 
            bgcolor: 'rgba(211, 47, 47, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            color: '#d32f2f'
          }}
        >
          <Lock sx={{ fontSize: 60 }} />
        </Box>
        
        <Typography 
          variant="h4" 
          fontWeight={700} 
          sx={{ 
            mb: 2,
            color: theme.palette.text.primary
          }}
        >
          Access Denied
        </Typography>
        
        <Typography 
          variant="body1" 
          sx={{ 
            mb: 4,
            color: theme.palette.text.secondary,
            fontSize: '1.1rem'
          }}
        >
          Sorry, you don't have permission to access this page. Please contact your administrator if you believe this is an error.
        </Typography>
        
        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          startIcon={<Home />}
          sx={{
            bgcolor: '#C4B08C',
            color: '#000',
            '&:hover': { bgcolor: '#b39d77' },
            px: 4,
            py: 1.5,
            borderRadius: 2,
            fontSize: '1rem',
            fontWeight: 600
          }}
        >
          Back to Home
        </Button>
      </Box>
    </Container>
  );
};

export default AccessDeniedPage;